import { useOffers } from "@/stores/admin/offers/offersStore";

export const detailingGamblingFieldsList = () => {
    const { isShowCommissions } = useOffers();

    return [
        {
            "label": "admin.statistics.statistics.table.labels.createdAt",
            "value": "createdAt"
        },
        {
            "label": "admin.statistics.statistics.table.labels.webmaster",
            "value": "webmaster.intId"
        },
        {
            "label": "admin.statistics.statistics.table.labels.leadId",
            "value": "id"
        },
        {
            "label": "admin.statistics.statistics.table.labels.country",
            "value": "country.name"
        },
        {
            "label": "admin.statistics.statistics.table.labels.domain",
            "value": "fields.domain"
        },
        {
            "label": "admin.statistics.statistics.table.labels.flow",
            "value": "flow.name"
        },
        {
            "label": "admin.statistics.statistics.table.labels.clickId",
            "value": "fields.clickId"
        },
        {
            "label": "admin.statistics.statistics.table.labels.remoteId",
            "value": "remoteId"
        },
        {
            "label": "admin.statistics.statistics.table.labels.ip",
            "value": "fields.ip"
        },
        {
            "label": "admin.statistics.statistics.table.labels.offerName",
            "value": "offer.detail.name"
        },
        {
            "label": "admin.statistics.statistics.table.labels.status",
            "value": "status"
        },
        isShowCommissions && {
            "label": "admin.statistics.statistics.table.labels.payouts",
            "value": "reward.webmasterReward.value"
        },
        isShowCommissions && {
            "label": "admin.statistics.statistics.table.labels.advertiserWriteOff",
            "value": "reward.advertiserWriteOff.value"
        },
        isShowCommissions && {
            "label": "admin.statistics.statistics.table.labels.currency",
            "value": "reward.webmasterReward.currency"
        },
        {
            "label": "admin.statistics.statistics.table.labels.utmCampaign",
            "value": "fields.utm_campaign"
        },
        {
            "label": "admin.statistics.statistics.table.labels.utmContent",
            "value": "fields.utm_content"
        },
        {
            "label": "admin.statistics.statistics.table.labels.utMmedium",
            "value": "fields.utm_medium"
        },
        {
            "label": "admin.statistics.statistics.table.labels.utmSource",
            "value": "fields.utm_source"
        },
        {
            "label": "admin.statistics.statistics.table.labels.utmTerm",
            "value": "fields.utm_term"
        }
    ].filter(Boolean);
};